import { CheckCircle2, AlertTriangle, XCircle, MinusCircle } from "lucide-react";

const GAP = {
  on_track: { label: "On track", cls: "border-emerald-200 bg-emerald-50 text-emerald-800", icon: CheckCircle2 },
  minor: { label: "Minor gap", cls: "border-amber-200 bg-amber-50 text-amber-900", icon: AlertTriangle },
  significant: { label: "Significant gap", cls: "border-rose-200 bg-rose-50 text-rose-800", icon: XCircle },
  no_data: { label: "No data", cls: "border-slate-200 bg-slate-50 text-slate-600", icon: MinusCircle },
};

export function GapBadge({ status, testid }) {
  const g = GAP[status] || GAP.no_data;
  return (
    <span data-testid={testid} className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${g.cls}`}>
      <g.icon className="h-3 w-3" /> {g.label}
    </span>
  );
}

const RS = {
  draft: "bg-slate-100 text-slate-700", submitted: "bg-sky-100 text-sky-800",
  accepted: "bg-emerald-100 text-emerald-800", returned: "bg-amber-100 text-amber-900",
};

export function ReportStatus({ status, testid }) {
  return <span data-testid={testid} className={`rounded-full px-2 py-0.5 text-[11px] font-semibold capitalize ${RS[status] || RS.draft}`}>{status}</span>;
}

export function GapReasons({ gap }) {
  if (!gap) return null;
  return (
    <div className="space-y-2">
      <ul className="space-y-1">
        {gap.reasons.map((r, i) => <li key={i} className="text-xs text-forest-dark">• {r}</li>)}
      </ul>
      {gap.checks?.length > 0 && (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          {gap.checks.map((c) => (
            <div key={c.key} className="rounded-lg border border-sage-light bg-white p-2">
              <div className="flex items-center justify-between gap-1 text-[11px]"><span className="font-medium">{c.label}</span><GapBadge status={c.status} /></div>
              <p className="mt-1 text-[11px] text-muted-foreground">Actual {c.actual}% · Target {c.target}%</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
